import { Adornment } from '@/components/controls';

export function AdornmentField({ input, ...props }) {
  return <Adornment value={input.value} onChange={input.onChange} {...props} />;
}
